import type { RefObject, Dispatch, SetStateAction } from 'react';

const GRAPH_CONFIG = {
  ORIGINAL_WIDTH: 740,
  ORIGINAL_HEIGHT: 560,

  AGE_SCALE_FACTOR: 36.5,
  BMI_SCALE_FACTOR: 18.5,

  X_OFFSET: 58,
  Y_OFFSET: 66,

  BMI_BASELINE: 8,
} as const;

export type MarkerPosition = {
  readonly left: number;
  readonly bottom: number;
};

export const updateMarkerPosition = (
  age: number,
  bmi: number,
  imageRef: RefObject<HTMLImageElement | null>,
  markerRef: RefObject<HTMLDivElement | null>,
  setMarkerPosition: Dispatch<SetStateAction<MarkerPosition>>
): void => {
  if (!imageRef.current || !markerRef.current) {
    return;
  }

  const graphImage = imageRef.current;
  const markerElement = markerRef.current;

  const widthScale = graphImage.width / GRAPH_CONFIG.ORIGINAL_WIDTH;
  const heightScale = graphImage.height / GRAPH_CONFIG.ORIGINAL_HEIGHT;

  const agePosition = age * (widthScale * GRAPH_CONFIG.AGE_SCALE_FACTOR);
  const bmiPosition = (bmi - GRAPH_CONFIG.BMI_BASELINE) * (heightScale * GRAPH_CONFIG.BMI_SCALE_FACTOR);

  const markerHalfWidth = markerElement.offsetWidth / 2;
  const markerHalfHeight = markerElement.offsetHeight / 2;

  const offsetX = GRAPH_CONFIG.X_OFFSET * widthScale;
  const offsetY = GRAPH_CONFIG.Y_OFFSET * heightScale;

  const finalLeft = agePosition + offsetX - markerHalfWidth;
  const finalBottom = bmiPosition + offsetY - markerHalfHeight;

  setMarkerPosition({
    left: Math.round(finalLeft * 1000) / 1000,
    bottom: Math.round(finalBottom * 1000) / 1000,
  });
};
